import { render, staticRenderFns } from "./QuestionsTypes.vue?vue&type=template&id=c15d7042&"
import script from "./QuestionsTypes.vue?vue&type=script&lang=js&"
export * from "./QuestionsTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports